import { render } from "./SectionOrder.vue?vue&type=template&id=be4dcc74"
import script from "./SectionOrder.vue?vue&type=script&lang=js"
export * from "./SectionOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__